import * as action from './actions';

import * as actionTypes from './actionTypes';

import { IDiscountSubscription, ISubscription } from 'types/subscription';
import { InferValueTypes } from 'types/commonTypes';

type ActionType = ReturnType<InferValueTypes<typeof action>>;

interface SubscriptionsState {
    subscriptions: ISubscription[];
    isLoading: boolean;
    isDiscountLoading: boolean;
    discountSubscription: IDiscountSubscription | null;
    // restoreCandidate: RestoreCandidate | null;
    cancellationCandidate: ISubscription | null;
    cancelReason: string;
}

const initialState = {
    subscriptions: [],
    isLoading: true,
    isDiscountLoading: false,
    discountSubscription: null,
    // TODO
    // restoreCandidate: null,
    cancellationCandidate: null,
    cancelReason: '',
};

const subscriptionsReducer = (state: SubscriptionsState = initialState, action: ActionType) => {
    switch (action.type) {
        case actionTypes.SET_FETCHING_STATUS:
            return { ...state, isLoading: action.payload };

        case actionTypes.SET_USER_SUBSCRIPTIONS:
            return { ...state, isLoading: false, subscriptions: action.payload };

        case actionTypes.SET_CANCELLATION_CANDIDATE:
            return { ...state, cancellationCandidate: action.payload };

        case actionTypes.SET_IS_DISCOUNT_LOADING:
            return { ...state, isDiscountLoading: action.payload };

        case actionTypes.SET_DISCOUNT_SUBSCRIPTION:
            return { ...state, discountSubscription: action.payload, isDiscountLoading: false };

        // case actionTypes.SET_RESTORE_CANDIDATE:
        //     return { ...state, restoreCandidate: action.payload };

        case actionTypes.SET_CANCEL_REASON:
            return { ...state, cancelReason: action.payload };

        default:
            return state;
    }
};

export default subscriptionsReducer;
